import { useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import useQuests from '../../../hooks/useQuests';
import { Quest, QuestAction, QuestState } from '../../../types/quests/indext';
import { tourDefaultState } from '../../../redux/tour/reducer';

/**
 * Hook to handle quest progress tracking
 */
const useQuestProgress = () => {
  const tourState = useSelector((state: any) => state.tour ?? tourDefaultState);
  const quests = useSelector((state: any) => state.quests); // Fixed: Access directly like useQuests hook
  const { handleDone } = useQuests();
  const isDoneRef = useRef(false);

  const calculateTourProgress = useCallback(() => {
    let progress = 0;
    if (tourState.pages.home) progress += 1;
    if (tourState.pages.marketplace) progress += 1;
    if (tourState.pages.adventure) progress += 1;
    if (tourState.pages.myLands) progress += 1;
    if (tourState.pages.preFight) progress += 1;
    if (tourState.pages.profile) progress += 1;
    if (tourState.pages.referral) progress += 1;
    if (tourState.pages.treasure) progress += 1;
    return progress;
  }, [tourState.pages]);

  // Check for tour guide quest progress
  useEffect(() => {
    if (quests && !isDoneRef.current) {
      const targetQuest = quests.find(
        ({ quest }: { quest: Quest }) =>
          quest?.requiredAction === QuestAction.CompleteTourGuide &&
          quest?.state === QuestState.Open
      );
      
      if (targetQuest) {
        isDoneRef.current = true;
        const progress = calculateTourProgress();
        if (progress > (targetQuest.progress || 0)) {
          handleDone(QuestAction.CompleteTourGuide, progress);
        }
      }
    }
  }, [quests, calculateTourProgress, handleDone]);

  return {
    calculateTourProgress
  };
};

export default useQuestProgress; 